<template>
    <span @click.stop="onClickFilter">
        <slot :focus="focus" :onDocumentClick="onDocumentClick" />
    </span>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import VgtBBFilter from './VgtBBFilter.vue'

@Component({
    components: {
        VgtBBFilter
    }
})
export default class VgtBBFilterButton extends Vue {
    focus = false

    onClickFilter () {
        this.focus = true
    }

    onDocumentClick (event) {
        this.focus = false
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vendors/vue-good-table/components/VgtBBFilterButton.vue